import {
  EDIT_REGISTRATION_FORM_REQUEST,
  EDIT_REGISTRATION_FORM_SUCCESS,
  EDIT_REGISTRATION_FORM_FAILED,
  GET_REGISTRATION_FORM_REQUEST,
  GET_REGISTRATION_FORM_SUCCESS,
  GET_REGISTRATION_FORM_FAILED,
} from './actionTypes';

const initialState = {
  registrationForm: null,
  loading: false,
  error: null,
};

const editRegistrationFormReducer = (state = initialState, {
  type, error, registrationForm,
}) => {
  switch (type) {
    case EDIT_REGISTRATION_FORM_REQUEST:
      return { ...state, loading: true };
    case EDIT_REGISTRATION_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        registrationForm: null,
      };
    case EDIT_REGISTRATION_FORM_FAILED:
      return { ...state, loading: false, error };
    case GET_REGISTRATION_FORM_REQUEST:
      return { ...state, loading: true, registrationForm: null };
    case GET_REGISTRATION_FORM_SUCCESS:
      return {
        ...state, loading: false, registrationForm,
      };
    case GET_REGISTRATION_FORM_FAILED:
      return {
        ...state,
        loading: false,
        error,
      };

    default:
      return state;
  }
};

export default editRegistrationFormReducer;
